import { Injectable, ChangeDetectorRef } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav, MatDialog } from '@angular/material';
import { ImagePopupDialogComponent } from '../components/popup-image/popup-image.component';
import { PopupImage } from 'src/app/models/popup-image';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  mobileQuery: MediaQueryList;
  // tslint:disable-next-line:variable-name
  private _mobileQueryListener: () => void;
  public sidenav: MatSidenav;
  public langSelected: string;

  // tslint:disable-next-line:variable-name
  constructor(public _dialog: MatDialog) { }

  startListener(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  setLanguage(language: string) {
    localStorage.setItem('langSelected', language);
    this.langSelected = language;
  }

  destoryListener() {
    this.mobileQuery.removeListener(this._mobileQueryListener);

  }

  toggleSidenav() {
    this.sidenav.toggle();
  }

  openDialog(widthPopup: string, dataPopup: PopupImage): void {
    const dialogRef = this._dialog.open(ImagePopupDialogComponent, {
      maxWidth: '96vw',
      maxHeight: '96vh',


      data: dataPopup
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('dialog closed..');
    });

  }
}

